import React, { useEffect, useRef, useState } from 'react'
import MetricItem from './MetricItem'
import AutoSizer from 'react-virtualized-auto-sizer'
import { VariableSizeList as List } from 'react-window'

const MetricList = props => {
  const listRef = useRef({})
  const rowHeights = useRef({})

  const [list, setList] = useState([])

  useEffect(() => {
    setList(props.metrics)
  }, [props.metrics])

  function getRowHeight (index) {
    return rowHeights.current[index] + 8 || 82
  }

  const row = ({ index, style }) => {
    const rowRef = useRef({})

    useEffect(() => {
      if (rowRef.current) {
        setRowHeight(index, rowRef.current.clientHeight)
      }
    }, [rowRef])

    return (
      <div key={index} style={style}>
        <MetricItem
          key={list[index].id}
          {...list[index]}
          units={props.units}
          clients={props.clients}
          ref={rowRef}
          onSelect={props.onSelect}
          onDelete={props.onDelete}
        />
      </div>
    )
  }

  const setRowHeight = (index, size) => {
    listRef.current.resetAfterIndex(0)
    rowHeights.current = { ...rowHeights.current, [index]: size }
  }

  return (
    <div style={{ flex: 1 }}>
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height - 84}
            itemCount={list.length}
            itemSize={getRowHeight}
            ref={listRef}
            width={width}
          >
            {row}
          </List>
        )}
      </AutoSizer>
    </div>
  )
}

export default MetricList
